import { Box, FormLabel, GridFilterModel, QuickFilter, QuickFilterControl } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useFilter } from './useFilter'

const isString = (value: string): value is string => typeof value === 'string'
export const useSearchFilter = () => {
  const [searchValues, updateSearchParam] = useFilter('search', { typeGuard: isString })
  const updateSearchValues = (filterModel: GridFilterModel) => {
    const searchTerms = filterModel.quickFilterValues?.filter((term) => typeof term === 'string')
    updateSearchParam(searchTerms?.join(','))
  }
  const searchTerms = React.useMemo(() => searchValues?.split(',').map((s) => s.trim()), [searchValues])

  return [searchTerms, updateSearchValues] as const
}

export const EmployeeSearchFilter = () => {
  return (
    <Box display="flex" flexDirection="column">
      <FormLabel>Name &amp; email</FormLabel>
      <QuickFilter variant="outlined" debounceMs={500}>
        <QuickFilterControl />
      </QuickFilter>
    </Box>
  )
}
